<div *ngIf="isGenerating">
    <div class="loader is-active padding-leader-3 padding-trailer-3">
        <div class="loader-bars"></div>
        <div class="loader-text">Loading...</div>
    </div>
</div>
<div class="alert alert-red is-active container" *ngIf="error">
    {{ errorMessage }}
</div>
<div class="bootstrap-wrapper">
    <div *ngIf="!error" id="onemap-report" class="legislative-asset-draft-tip-report">
        <div class="reportSection">
            <div class="reportSectionHeader">
                Legislative Asset Draft TIP Report
            </div>
            <div class="reportSectionContent container">
                <div class="row">
                    <div class="col-xs-4">
                        Legislator:&nbsp;{{ searchLocation.lastName }} {{ searchLocation.firstName }}({{ searchLocation.party }})
                    </div>
                    <div class="col-xs-4">
                        Legislative Type:&nbsp;{{ searchLocationType }}
                    </div>
                </div>
                <!-- Row -->
            </div>
            <!-- Content -->
        </div>
        <!-- Section -->
        <div class="reportSection">
            <div class="reportSectionHeader">
                Totals
            </div>
            <div class="reportSectionContent container" *ngIf="reportData && reportData.summary">
                <div class="row">
                    <div class="col-xs-2">
                        {{ reportData.summary[0].title }}:&nbsp;{{ reportData.summary[0].cnt }}
                    </div>
                    <div class="col-xs-2">
                        {{ reportData.summary[1].title }}:&nbsp;{{ reportData.summary[1].cnt }}
                    </div>
                    <div class="col-xs-2">
                        {{ reportData.summary[2].title }}:&nbsp;{{ reportData.summary[2].cnt }}
                    </div>
                    <div class="col-xs-2">
                        {{ reportData.summary[3].title }}:&nbsp;{{ reportData.summary[3].cnt }}
                    </div>
                    <div class="col-xs-2">
                        {{ reportData.summary[4].title }}:&nbsp;{{ reportData.summary[4].cnt }}
                    </div>
                </div>
                <!-- Row -->
            </div>
            <!-- Content -->
        </div>
        <!-- Section -->
        <div class="reportSection">
            <div class="reportSectionHeader">
                IRI
            </div>
            <div class="reportSectionContent container" *ngIf="reportData && reportData.summary">
                <div class="row">
                    <div class="col-xs-3">
                        {{ reportData.summary[8].title }}:&nbsp;{{ reportData.summary[8].cnt }}
                    </div>
                    <div class="col-xs-3">
                        {{ reportData.summary[7].title }}:&nbsp;{{ reportData.summary[7].cnt }}
                    </div>
                    <div class="col-xs-3">
                        {{ reportData.summary[6].title }}:&nbsp;{{ reportData.summary[6].cnt }}
                    </div>
                    <div class="col-xs-3">
                        {{ reportData.summary[5].title }}:&nbsp;{{ reportData.summary[5].cnt }}
                    </div>
                </div>
                <!-- Row -->
            </div>
            <!-- Content -->
        </div>
        <!-- Section -->
        <div class="reportSection">
            <div class="reportSectionHeader">
                Map
            </div>
            <div class="reportSectionContent container">
                <div class="row">
                    <div class="col-xs-12">
                        <mc-load-message *ngIf="!mapIsLoaded" message="Loading map"></mc-load-message>
                        <div style="width:700px;height:300px;position:relative;">
                            <mc-map #mcMap></mc-map>
                        </div>
                    </div>
                </div>
                <!-- Row -->
            </div>
            <!-- Content -->
        </div>
        <!-- Section -->
        <div class="reportSection">
            <div class="reportSectionHeader">
                Projects
            </div>
            <div class="projectTableSection">
                <table class="projectTable table" aria-label="Projects">
                    <thead>
                        <tr>
                            <th>Project ID</th>
                            <th>Primary Improvement Type</th>
                            <th>Primary SR</th>
                            <th>Section</th>
                        </tr>
                    </thead>
                    <tbody *ngIf="reportData && reportData.projects">
                        <tr *ngFor="let project of reportData.projects">
                            <td><a href="?projectId={{ project.projectId }}" target="blank">{{ project.projectId }}</a></td>
                            <td>{{ project.primaryImprovementType }}</td>
                            <td>{{ project.primarySr }}</td>
                            <td>{{ project.section }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
